import styled from "styled-components";
import { Tabs } from "antd";

export const StyledTabs = styled(Tabs)`
  /* .Tabs-container { */ 
  width: 500px !important;
  height: 425px !important;
  /* } */
  .ant-tabs-nav .ant-tabs-tab:nth-child(2) {
    margin-left: 0px !important;
  }

  .ant-tabs-nav .ant-tabs-tab {
    border-radius: 0px !important;
    font-size: 16px !important;
  }

  .ant-tabs-nav {
    margin: 0px !important;
  }

  .ant-tabs-content-holder {
    border-width: 1px;
    border-color: #f0f0f0;
    border-style: solid;
    border-top-style: none;
    // padding: 1rem;
    overflow: auto;
  }

  .msg-card {
    width: 100%;
    margin: 4px 5px;
    background: #fafafa;
    display: flex;
    justify-content: space-between;
    padding: 5px 10px;
    cursor: pointer;
  }
  .avatar {
    border-radius: 50%;
    width: 50px;
    height: 50px;
    margin-top: 4px;
    margin-right: 10px;
  }
  .swipeable-list {
    height: auto;
  }
  @media only screen and (max-width: 999px) {
    width: 275px !important;
  }
  .avatar {
    border-radius: 50%;
    width: 35px;
    height: 35px;
    margin-top: 4px;
    margin-right: 10px;
  }
  .send-name-para {
    font-size: 13px !important;
  }
  .message-name-para {
    font-size: 12px;
  }
  .date-div {
    font-size: 13px !important;
    white-space: nowrap;
  }
  .task{
    display: flex;
    justify-content: space-between;
    padding: 15px 15px;
    fontsiz
  }
  .task-label{
    font-size: 14px;
    font-family:auto;
  }
`;
